/**
 * Included into the footer of pages.
 */

import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup"; 

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
new MainMenu({
	menu: '#menu',
	menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.menu-item-has-children > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

import SiteAnimations from './component/SiteAnimations';
const animatedStripes = ['.section > .wp-block-group', '.section > .wp-block-cover']
new SiteAnimations([
	{
		observedSelector: '.masthead, ' + animatedStripes.join(', '),
		options: {
			rootMargin: '-50px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: animatedStripes.join(':first-child, '),
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	}
]);
